<template lang="html">
  <div class="main-lang" v-if="show">
    <div class="name">
      {{message.Sl159}}
      <i class="material-icons close" @click="close">
        close
      </i>
    </div>
    <div class="box">
      <div class="cell">
        <el-radio class="radio" v-model="radio" label="zh-cn">简体中文</el-radio>
      </div>
      <div class="cell">
        <el-radio class="radio" v-model="radio" label="en">English</el-radio>
      </div>
      <div class="cell no" style="text-align:center">
        <el-button type="primary" :disabled="change" @click="changeLang">
          {{message.Fl102}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      el: 'el',
      app: 'app'
    })
  },
  watch: {
    'el.showLang': function (val) {
      this.show = val
      this.radio = this._global.config.language
    },
    radio: function (val) {
      if (val !== this.radioOld) {
        this.change = false
      } else {
        this.change = true
      }
    }
  },
  data () {
    return {
      message: {
        Sl159: this.$lang.ui.system.l159,
        Fl102: this.$lang.ui.form.l102
      },
      show: false,
      change: true,
      radio: this._global.config.language,
      radioOld: this._global.config.language
    }
  },
  mounted () {
    this.$store.dispatch('showLang', false)
    this.radio = this._global.config.language
  },
  methods: {
    changeLang () {
      if (!this.change) {
        localStorage.setItem('langSet', this.radio)
        let params = {
          language: this.radio === 'zh-cn' ? 'zh-cn' : 'en',
          time_zone: this._global.config.timezone,
        }
        this.$api.changeTimezone(params)
        if (this.app.login) {
          if (this.radio === 'zh-cn') {
            var l = 1
          } else {
            l = 0
          }
          this.$app.setOption(l, response => {
            setTimeout(() => {
              window.location.reload()
            }, 300)
          })
        } else {
          setTimeout(() => {
            window.location.reload()
          }, 300)
        }
      }
    },
    close () {
      this.$store.dispatch('showLang', false)
      this.show = false
    }
  }
}
</script>

<style lang="css" scoped>
.main-lang {
  z-index: 9999;
  position: fixed;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  margin-left: -200px;
  margin-top: -130px;
  top: 42%;
  left: 50%;
  width: 400px;
  height: auto;
  border-radius: 8px;
  background-color: #fff;
  font-size: 14px;
}
.name {
  position: relative;
  font-weight: 600;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #0291cf;
}
.name span {
  position: absolute;
  top: 0;
  right: 18px;
  height: 100%;
  display: block;
  color: #fff;
  float: right;
  font-size: 21px;
  cursor: pointer;
}
.name span:hover {
  font-size: 25px;
}
.box {
  width: 100%;
  padding: 20px 45px 14px 45px;
}
.cell {
  width: 100%;
  padding: 12px 0;
  padding-left: 8px;
  overflow: hidden;
  text-align: left;
  border-bottom: 1px solid #ccc;
}
.cell.no {
  border: 0;
  padding-left: 0;
  margin-top: 10px;
}
.close {
  margin: 4px 4px 0 0;
  float: right;
  cursor: pointer;
}
</style>
